import { PhotoGridPositionsEnum, VerifStatusEnum } from '@/lib/enum.ts';
import { Button } from '@/components/ui/button.tsx';
import { IUserPicture } from '@/lib/interface.ts';
import { cn, getPhotoUrl } from '@/lib/utils.ts';
import { Card } from '@/components/ui/card.tsx';
import ImgUserPicture from './ImgUserPicture';
import { BadgeCheck } from 'lucide-react';

type TProps = {
	userId: string;
	withButtons?: boolean;
	picture: IUserPicture;
	onClickDeletePictureBtn?: (userId: string, picture: IUserPicture) => void;
	onClickAcceptDenyBtn?: (
		accept: boolean,
		userId: string,
		position: PhotoGridPositionsEnum,
	) => void;
	className?: string;
	readonly?: boolean;
}

const PhotoVerificationItemCard = ({
	picture,
	userId,
	className,
	onClickDeletePictureBtn,
	onClickAcceptDenyBtn,
	withButtons = true,
	readonly = false
}: TProps) => (
	<Card className={`w-[160px] md:w-[180px] self-start ${className}`}>
		<div className={'relative'}>
			<ImgUserPicture
				enableFullScreen
				alt={'user photo'}
				role='button'
				src={getPhotoUrl(picture.path)}
				className={cn(
					`w-full h-full object-contain`,
					withButtons
						? 'rounded-t-md'
						: 'rounded-md'
				)} />
			{picture.status !== VerifStatusEnum.PENDING
				? picture.verifiedBy &&
				picture.verifiedBy?.username && (
					<div className={'absolute bottom-1 left-1 right-1'}>
						<div className={'flex items-center space-x-1 bg-white text-xs rounded p-0.5'}>
							<BadgeCheck
								size={16}
								fill='#9333ea'
								color='white' />
							<span className='overflow-hidden truncate'>
								Par: {picture.verifiedBy?.username}
							</span>
						</div>
					</div>
				)
				: null}
		</div>

		{/* Buttons */}
		{
			(readonly || picture.position === PhotoGridPositionsEnum.CERTIF)
				? null
				: picture.status === VerifStatusEnum.PENDING
					? (
						onClickAcceptDenyBtn &&
						<div className={`grid grid-cols-2 p-1.5 gap-2`}>
							<Button
								size={'sm'}
								variant={'default'}
								className={'w-full text-red-500 bg-red-100 hover:bg-red-200/80'}
								onClick={() => onClickAcceptDenyBtn(false, userId, picture.position)}>
								Refuser
							</Button>
							<Button
								size={'sm'}
								variant={'default'}
								className={'w-full text-green-600 bg-green-100 hover:bg-green-200/80'}
								onClick={() => onClickAcceptDenyBtn(true, userId, picture.position)}>
								Accepter
							</Button>
						</div>
					)
					: onClickDeletePictureBtn &&
					<div className={'p-1.5'}>
						<Button
							size={'sm'}
							variant={'ghost'}
							className={'w-full text-red-500 hover:text-red-500 hover:bg-red-200/80'}
							onClick={() => onClickDeletePictureBtn?.(userId, picture)}>
							Supprimer
						</Button>
					</div>
		}
	</Card>
);

export default PhotoVerificationItemCard;
